import { render } from "./NoteApp.vue?vue&type=template&id=2fdcd80e"
import script from "./NoteApp.vue?vue&type=script&lang=js"
export * from "./NoteApp.vue?vue&type=script&lang=js"

import "./NoteApp.vue?vue&type=style&index=0&id=2fdcd80e&lang=css"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__